<template>

    <div :style="pageStyle" id="listContainer" ref="chatContatiner" @scroll="showScorll" class="chatContatiner" @click="globalClick">

        <template v-if="arrayList && arrayList.length > 0" >
            <div  v-for="item, index in arrayList" :id="'QICON' + index" style="margin-bottom: 25px;" v-bind:key="index">

                <template v-if="item.msgType == 0">
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="QICON">
                            <template v-if="item.load == true">
                                <div class="QICONIcon" style="text-align: center;">
                                    <SyncOutlined style="font-size: 16px;color: white;" spin></SyncOutlined>
                                </div>



                            </template>
                            <template v-else>
                                <img src="../../../assets/ailogo.png" style="width: 100%;position: relative;" />
                            </template>
                        </div>
                        <!-- <div style="align-content: center;font-size: 16px;font-weight: bolder;    margin-left: 5px;">
                            Qiuu~
                        </div> -->
                    </div>
                  
                    <div style="font-size: 16px;" v-if="!item.load">
                      

                        <div style="font-size: 16px;width: 100%;">
                            <div class="chat-bubble chat-bubble-left ai-chat">
                                <!---引用-->
                           


                                <div class="html"    
   v-html="item.vhtml" @click.stop="knowledgeRefClick($event)"></div>
                            
                                <div v-if="!item.load == true&&item.paragraphs&&item.paragraphs.length>0">
                                    <div style="color: #756ddd;font-weight: bolder;">
                                        <div @click="toShowArray(index)">知识库引用
                                            <DownOutlined v-if="!item.showParagraphs" />
                                            <UpOutlined v-else />
                                        </div>

                                        <template v-if="item.showParagraphs">
                                            <div v-for="(itemItem,itemIndex) in item.paragraphs" v-bind:key="itemIndex">
                                                <!-- <div  class="html"  v-html="md.render(itemItem.content) "></div> -->
                                                <a @click="toShowContent(index,itemIndex)">{{itemIndex+1}}、{{itemItem.dataSetName
                                                    }}</a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                
                            
                        </div>


                    </div>
                    <div class="loading-dots" v-if="item.load==true&&item.done==false"  style="    margin-top: 10px;">正在思考中🤔</div>
                           
                </template>
                <template v-if="item.msgType == 1">

                    <div style="    text-align: right;display: flex;width: 100%;justify-content: flex-end;">


                        <div style="font-size: 16px;width: 100%;">
                            <div class="chat-bubble chat-bubble-right">
                                <span style="white-space: pre-line">{{ item.data }}</span>
                            </div>


                        </div>

                    </div>

                </template>


            </div>

        </template>
    </div>


    <a-modal centered width="70%" :title="title" v-model:visible="contentModal" :closable="false"
        @ok="contentModal=false">
        <div v-html="md.render(content)" class="html">

        </div>
    </a-modal>
       
             <!--引用-->
     <div v-if="knowledgeRefContent.flag" @click.stop="knowledgeRefContentClick" id="knowledgeRefContent"
		:style='{top:knowledgeRefContent.top,"z-index":knowledgeRefContent.index,"max-height":knowledgeRefContentHieght+"px"}'
		class="knowledgeRefContent">
        <div>
			<div style="margin-bottom: 8px;">{{knowledgeRefContent.title}}</div>
		</div>
         <div style="overflow-y: auto;   flex-grow: 1; ">
            <div style="text-align: justify;color:black" v-html="md.render(knowledgeRefContent.content)" ></div>
        </div>

	</div>
    <!-- <div @click="stopRequest">停止生成</div> -->

</template>
<script setup>
import $  from 'jquery'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';

import { fetchEventSource } from '@microsoft/fetch-event-source';


import { nextTick, onMounted, reactive, ref, watch, defineProps, defineEmits } from 'vue'
import { SyncOutlined } from "@ant-design/icons-vue"
import { toChatPage, recordChatPage } from '../qiuuindex';
import { toChatKimi } from '../gptTorch'

import store from '@/store';
import router from '@/router';
const showProp = defineProps(['postParams', 'sendText', 'active', 'conversationId', 'articleAppId', 'articleType', 'pageHeight', 'cardList','sessionList'])
const showEmit = defineEmits(['toChangeSelectTrue', 'toChangeSendText', 'toChangeSendTextTrue', 'toReloadSession', "toShow"])
import MarkdownIt from 'markdown-it'
import { repeat } from 'lodash';

import { useSSEByXHR } from '@/untils/useSSE';


const md = new MarkdownIt({ html: true })
const conversationId = ref(null)
const pageStyle = ref()

const controller = new AbortController();
watch(() => showProp.active, (val, old) => {
    console.log(val.active != old.active, val, old, ' watchshowProp.active')

    if (val.articleAppId != '') {

        if (val.active != old.active) {
            arrayList.value = []
            pagination.total = 0
            pagination.current = 1

            nextTick(() => {
                if (val.active && val.active != 'newChat' && old.active == 0) {

                    reloaddata(true, true)
                }
            })
        }

    }

})
watch(() => router.currentRoute.value.query, (val, old) => {




    if (val && val.id && val.id != 'newChat') {
        arrayList.value = []
        pagination.total = 0
        pagination.current = 1

        reloaddata(true, true)
    }




})
const showContentButton = ref(false)
const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
const avatarSrc = ref(store.getters.avatar)
const pagination = reactive({
    current: 1,
    size: 10,
    total: 0,
    pages: 0,

})
const toShowArray = (index) => {

    arrayList.value[index].showParagraphs = !arrayList.value[index].showParagraphs
}
const chatContatiner = ref(null)
const reloaddataFlag = ref(false)
const previousScrollHeight = ref(0)

const setShowScroll = ref(false)
const showScorll = (e) => {

        if (pageScrollButtom.value == true) {
            console.log(reloaddataFlag.value, 'showScorll')
            console.log(arrayList.value.length, pagination.pages, pagination.current, "showScorll", pagination.current + 1, chatContatiner.value.scrollTop)
            if (chatContatiner.value.scrollTop == 0 && arrayList.value.length > 0) {
                if (pagination.pages > pagination.current) {

                    reloaddataFlag.value = true
                    pagination.current = pagination.current + 1
                    const previousScrollHeight = chatContatiner.value.scrollHeight;
                    reloaddata(true, false)

                }
            }
        }
        else {
            pageScrollButtom.value = true
        }
 


    console.log(pageScrollButtom.value, 'pageScrollButtom.valu')


}
const getArrayType = (value) => {
    if (value && Array.isArray(value)) return true
    return false
}
watch(() => showProp.pageHeight, (val) => {

    if (showProp.articleType != '网络搜索') {
        pageStyle.value = { 'height': showProp.pageHeight + 'px', 'overflow-y': pagination.pages > 1 ? 'scroll' : 'auto', 'padding': '20px 80px', }

    }

})
const paragraphs = ref([])
const title = ref("")
const content = ref("")
const contentModal = ref(false)
const toShowContent = (index, Index) => {
    title.value = arrayList.value[index].paragraphs[Index].dataSetName
    content.value = changeContent(arrayList.value[index].paragraphs[Index].content)
    console.log(content.value)
    contentModal.value = true
}
const knowledgeRefContent=ref({
    flag:false,
    title:"",
    content:"",
    top:0,
    index:0
}) 
//点击全局隐藏知识库引用
const globalClick=()=>{
    console.log('globalClick')
    knowledgeRefContent.value.flag=false
}
//点击知识库引用内容不隐藏
const knowledgeRefContentClick=()=>{
    console.log('knowledgeRefContentClick')
    return 
}
const knowledgeRefContentHieght=ref(300)
const changeContent=(val)=>{
  return val.replace(
    /\/kb\/oss_file\/([^\s\)]+\.png)/g,
    'https://ais.prod.torchv.com/kb/oss_file/$1'
  )
}
//点击知识库引用显示内容
const knowledgeRefClick=(event)=>{
    if ( router.currentRoute.value.query.knowId&&event.target.className == 'citation-link') {
        //知识库
  
        const citationNum = event.target.getAttribute('data-citation');
        const id=event.target.getAttribute('data-id');
        console.log('点击了知识库引用', event,arrayList.value,Number(id))
        var item= arrayList.value.find(item=>item.id==Number(id))
        item=item.originParagraphs.find(item=>item.index==Number(citationNum))
        knowledgeRefContent.value={
            flag:true,
            title:item.dataSetName,
            content:changeContent(item.content),
            top:(event.clientY)+'px',
            index:0
        }
        console.log(' knowledgeRefContent.value=', knowledgeRefContent.value)
        nextTick(()=>{
            console.log( $('.knowledgeRefContent').outerHeight())
            //因为知识库的最近父元素设置了padding，所以这里需要减去padding的高度60px
            var top=event.clientY - $('.knowledgeRefContent').outerHeight()-10-60
            //如果知识库内容高度超出页面高度,那么现实在最下面，否则显示在上面
            if(top<0){
                top=event.clientY
            }
			knowledgeRefContent.value.top = top + 'px'
			knowledgeRefContent.value.index = 10
        })
        	

    }
    else{
        knowledgeRefContent.value.flag=false
    }
}



const { startSSE, stopSSE, isStreaming } = useSSEByXHR()

const toGetNoRepeatReference = (paragraphs) => {
    var noRepeatList = []
    if (paragraphs && paragraphs.length > 0) {

        paragraphs.forEach(element => {
            if (noRepeatList.findIndex(item => item.dataSetName == element.dataSetName) == -1) {
                var dataSetName = element.dataSetName
                const map = new Map();

                paragraphs
                    .filter(i => i.dataSetName === dataSetName)
                    .forEach(item => {
                        if (!map.has(item.page)) {
                            map.set(item.page, item); // 只保存第一次出现的
                        }
                    });


                var list = [...map.values()].sort((a, b) => a.page - b.page);
                var content = ""
                for (var listItem of list) {
                    content = content + listItem.content + "\n"
                }
                noRepeatList.push({
                    dataSetName: dataSetName,
                    content: content
                })
               
            }
        });
    }
    else noRepeatList = paragraphs
    console.log(noRepeatList,'toGetNoRepeatReference')
    return noRepeatList
}
const reloaddata = async (val, scrollFlag) => {

    showEmit('toChangeSelectTrue', true)
  
    if (val == true && showProp.active.active != 'newChat' && router.currentRoute.value.query.id && router.currentRoute.value.query.id != 'newChat') {
           if((!showProp.sessionList||showProp.sessionList.length==0)&&showProp.articleType=='网络搜索') return;
        console.log(showProp.cardList, 'showProp.cardList', router.currentRoute.value.query.id)
        recordChatPage({ id: router.currentRoute.value.query.id, current: pagination.current, size: 10 }).then((res) => {

            pagination.total = res.data.total
            pagination.pages = res.data.pages
            var result = res.data.records

            for (var i in result) {
                console.log('recordChatPage')

                arrayList.value.push({
                    id: result[i].id, table: false, load: false, data: result[i].message, msgType: result[i].msgType,
                    originParagraphs: result[i].jsonData ? result[i].jsonData.paragraphs : [],
                    paragraphs: result[i].jsonData ? toGetNoRepeatReference(result[i].jsonData.paragraphs) : [], showParagraphs: false,
                    vhtml:result[i].msgType==0?md.render(transformCitations(result[i].id,result[i].message)):""
                })
            }
            if (arrayList.value.length > 0) {
                 const map = new Map();
              arrayList.value.forEach(item => map.set(item.id, item));
               arrayList.value = [...map.values()];
            }

            arrayList.value = arrayList.value.length > 0 ? arrayList.value.sort((a, b) => a.id - b.id) : arrayList.value
         
            console.log(arrayList.value, "arrayList.value")

            showEmit('toChangeSendText')
            showEmit('toChangeSelectTrue', false)


            if (scrollFlag != false)
                scrollButtom(false)

        })


    }
    else {
        var postData = showProp.postParams
        var result

        if (val == false) {
            result = {
                load: false,
                data: showProp.sendText.sendText,
                summary: null,
                type: postData,
                table: false,
                msgType: 1,
                id: arrayList.value.length > 0 ? arrayList.value[arrayList.value.length - 1].id + 1 : 1
         
            }
          
            arrayList.value.push(result)
            showEmit('toChangeSendText')

        }

        if (arrayList.value && arrayList.value.length > 0) {
           

            arrayList.value.push({ load: true, msgType: 0, id: arrayList.value[arrayList.value.length - 1].id + 1, data: "",
                      done:false
            })



               


                console.log(store.getters.appList, router.currentRoute.value.query.knowId, 'xixi')
                var dataStream = ""
                let renderTimer = null

                try {
                    let renderTimer = null

                    var fetchPostData=null
            if(showProp.articleType=='网络搜索'){
 fetchPostData=  JSON.stringify({
                           
                            clientId: store.getters.clientId,
                            companyId: store.getters.company.companyId,
                            "conversationId": router.currentRoute.value.query.conversationId ? router.currentRoute.value.query.conversationId : null,
                            "question": showProp.sendText.sendText,
                            "type": 2
                        })
            }
            else{
             fetchPostData=  JSON.stringify({
                            "appId": store.getters.appList.find(item => item.id == Number(router.currentRoute.value.query.knowId)).appId,
                            clientId: store.getters.clientId,
                            companyId: store.getters.company.companyId,
                            id: Number(router.currentRoute.value.query.knowId),
                            "conversationId": router.currentRoute.value.query.conversationId ? router.currentRoute.value.query.conversationId : null,
                            "question": showProp.sendText.sendText,
                            "type": showProp.articleType == '网络搜索' ? 2 : 1,
                        })
            }
            //https://www.enplus.org.cn/v3/chat/streamingChat
                   fetchEventSource('https://www.enplus.org.cn/v3/chat/streamingChat', {
                        method: 'POST',
                        signal: controller.signal,
                        headers: {
                            "Content-Type": 'application/json',
                        },
                        openWhenHidden: true,
                        body: fetchPostData,
                        onmessage: function (event) {
                            console.log('event',event.data)
                            showEmit('toChangeSendTextTrue', false)
                            showEmit('toChangeSelectTrue', false)
                     

                            if(showProp.articleType=='网络搜索'&&event.data!='[DONE]'){
                        
                                let data =JSON.parse(event.data)
                    
                                    if(data.choices[0].delta.content.length>0){

                              // ⭐ 用 setTimeout 强制放到下一个宏任务
            
                    const item = arrayList.value[arrayList.value.length - 1];
                    
                    if (item.load == true) {
                        item.load = false;
                    }
                    nextTick(()=>{
                        // 累积数据
                    item.data += data.choices[0].delta.content;
                    item.done = false;
                    
                    // ⭐ 关键：重新赋值 vhtml 触发响应式
                    const newHtml = md.render(transformCitations(item.id, item.data));
                      // ⭐⭐⭐ 精确查找对应的 .html 元素
            // const targetElement = document.querySelector(`.html[data-chat-id="${item.id}"]`);
            // console.log(targetElement,'targetElement',item.id)
            // if (targetElement) {
            //     console.log(targetElement.innerHTML,'newHtml',newHtml)
            //     targetElement.innerHTML = newHtml;
            // }
                  nextTick(()=>{
                      item.vhtml = newHtml;
                    
                    console.log('data网络搜索', item.load, item.vhtml);
                    conversationId.value = data.conversationId;
                     // ⭐ 强制触发 Vue 更新
                    nextTick(() => {
                        scrollButtom(true);
                    });
                  })
                

                   
                    })
                    
                    
         
                               
                            
                               
                                }
                       
                             
                            }
                            else if(showProp.articleType=='网络搜索'&&event.data=='[DONE]'){
                                
                                nextTick(()=>{
arrayList.value[arrayList.value.length - 1].done=true
                                }) 
                            }
                           
                            else if (showProp.articleType!='网络搜索'&&event.data.indexOf('data:') == 0) {
                             
                                let data = JSON.parse(event.data.substring(5, event.data.length));
                                if (data.choices && data.choices.length > 0 && data.choices[0].message) {
                            
                                
                                    if(data.choices[0].message.content){
                                       
                                     
                                        console.log('data.choices[0].message.content',data.choices[0].message.content)
                                  
                                    arrayList.value[arrayList.value.length - 1].data = arrayList.value[arrayList.value.length - 1].data + data.choices[0].message.content
                                    arrayList.value[arrayList.value.length - 1].vhtml = md.render(transformCitations(arrayList.value[arrayList.value.length - 1].id, arrayList.value[arrayList.value.length - 1].data))
                                 
                                    console.log(data.paragraphs, 'paragraphs')
                                   
                                    console.log(data.choices[0], 'data.choices[0]')
                                   
                                    }
                                    arrayList.value[arrayList.value.length - 1].paragraphs = toGetNoRepeatReference(data.paragraphs)
                                    arrayList.value[arrayList.value.length - 1].originParagraphs= data.paragraphs?data.paragraphs:[]
                                    paragraphs.value = arrayList.value[arrayList.value.length - 1].paragraphs
                                    arrayList.value[arrayList.value.length - 1].showParagraphs = false
                                   
                                      conversationId.value = data.conversationId
                                      scrollButtom(true)
                                      if((arrayList.value[arrayList.value.length - 1].data&&arrayList.value[arrayList.value.length - 1].data.length>0)||
                                        (arrayList.value[arrayList.value.length - 1].paragraphs&&arrayList.value[arrayList.value.length - 1].paragraphs.length>0)
                                      ){
                                         arrayList.value[arrayList.value.length - 1].load = false
                                         arrayList.value[arrayList.value.length - 1].done=true
                                      }
                                   
                                }
                               

                            }
                            // clearTimeout(timeoutId);

                        },
                        onerror(error) {
                          
                                
                      
                                arrayList.value[arrayList.value.length - 1].done=true
                        
                          
                            showEmit('toChangeSendTextTrue', false)
                            showEmit('toChangeSelectTrue', false)
                            arrayList.value[arrayList.value.length - 1].load = false
                            arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                            scrollButtom(true)
                            console.log('Stream encountered error:', error);
                            //   clearTimeout(timeoutId);
                            throw error;
                        },
                        onclose() {
                            console.log('onclose:', 'onclose');
                            arrayList.value[arrayList.value.length - 1].load = false
                            pagination.total = arrayList.value.length
                            if ((showProp.conversationId == null)) {

                                showEmit('toReloadSession', conversationId.value)
                                conversationId.value = null

                            }
                            else {

                                if (arrayList.value[arrayList.value.length - 1].data == '') {
                                    showEmit('toChangeSendTextTrue', false)
                                    showEmit('toChangeSelectTrue', false)
                                    arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                                    scrollButtom(true)
                                }

                                paragraphs.value = null
                            }
                            
                                
                      
                                arrayList.value[arrayList.value.length - 1].done=true
                        
                           

                            //   clearTimeout(timeoutId);
                        },



                    })
                } catch (error) {
                    console.log('catcherror', error)
                    showEmit('toChangeSendTextTrue', false)
                    showEmit('toChangeSelectTrue', false)
                    arrayList.value[arrayList.value.length - 1].load = false
                    arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                   
                                
                      
                                arrayList.value[arrayList.value.length - 1].done=true
                        
                          
                    scrollButtom(true)
                    // clearTimeout(timeoutId);
                }

            
          
        }


    }

    nextTick(() => {
        showEmit('toShow')
        var element = document.getElementById('listContainer');
        console.log(element)
        if (element) {
            //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
            element.scrollTop = element.scrollHeight;
        }


        if (showProp.articleType == '网络搜索') {

            nextTick(() => {
                var parentELement = document.querySelector('.QP')

                if (parentELement) {

                    var childrenElement = document.querySelector('.QP-Header')

                    if (childrenElement) {
                        console.log(parentELement.offsetHeight + "" + childrenElement.offsetHeight + "childrenElement.offsetHeight")
                        var pageHeight = parentELement.offsetHeight - childrenElement.offsetHeight - 40 - 42 - 10 - 20 -10

                        console.log(pageHeight, 'pageHeight')
                        pageStyle.value = { 'height': pageHeight + 'px', 'overflow-y': 'auto', 'padding': '20px 280px' }

                    }
                }
            })
        }
        else {

            pageStyle.value = { 'height': showProp.pageHeight + 'px', 'overflow-y': pagination.pages > 1 ? 'scroll' : 'auto', 'padding': '20px 80px', }

        }






    })
}

const stopRequest = () => {
    controller.abort();
};




const pageScrollButtom = ref(true)
const scrollButtom = (flag) => {

    nextTick(() => {

        if (pagination.current == 1) pageScrollButtom.value = false
        var element

        if (flag == true || flag == false) {

            // if(showProp.articleType!='网络搜索'){
            element = document.getElementById('listContainer');

            // console.log(element, 'element.scrollHeight', element.scrollHeight)
            if (element) {
                //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                element.scrollTop = element.scrollHeight;
                console.log(element.scrollHeight, 'element.scrollHeight')
            }
            // }
            // else if (arrayList.value.length > 2) {
            //     element = document.getElementById('QICON' + (arrayList.value.length - 1).toString());
            //     var pelement = document.getElementById('listContainer');
            //     console.log(element, 'QICON' + pelement.clientHeight, pelement.scrollTop, element.offsetTop - 100)
            //     pelement.scrollTop = element.offsetTop - 100
            // }


        }
        else {
            element = document.getElementById('listContainer');
            // console.log(element, 'element.scrollHeight', element.scrollHeight)
            if (element) {
                //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                element.scrollTop = element.scrollHeight;
            }
        }



    })
}
const isArray = (val) => {
    return val instanceof Array
}







const arrayList = ref([

])
//变 a标签
const transformCitations = (id,text) => {
    console.log(text,'transformCitations')
    if(showProp.articleType=='网络搜索') return text
    else{
       text = changeContent(text)
        return text.replace(/\[(\d+)\]/g, (match, num) => {
        return `<a    class="citation-link" data-id="${id}"   data-citation="${num}">[${num}]</a>`
    })
}
    }
    
watch(() => router.currentRoute.value.query, (val, old) => {
    console.log(val, old, 'arrayList')
    arrayList.value = []
    if(showProp.articleType=='网络搜索'&&val.conversationId==null){
        pageStyle.value=""
    }

})
watch(() => showProp.postParams, (val) => {

    if (val != null) {
        reloaddata()
    }
})

watch(() => showProp.sendText, (val) => {
    console.log(val, 'showProp.sendText')
    if (val != null && val.send == true) {
        reloaddata(false)
    }
})

onMounted(() => {





})
</script>
<style lang="less">
.html {
    padding: 0px 5px;
    padding-left: 10px;

    //    li::marker {
    //   color: red;
    //   font-size: 1.5em;
    //   margin-left:10px;


    // }
    p {
        margin-bottom: 0px;
        white-space: pre-line;
    }

    img {
        width: -webkit-fill-available;
    }

}

.markdown {
    td {
        padding-right: 20px;
    }
}

.chatTable {
    thead tr th:nth-of-type(1) {
        padding: 1px;
    }

}

ul {
    list-style-type: none;
}
</style>
<style scoped>
.loading-dots{
    font-size: 14px;
    margin-top: 10px;
}
.loading-dots::after {
    content: '';
    animation: dots 1.5s steps(4) infinite;
}

@keyframes dots {
    0% { content: ''; }
    25% { content: '.'; }
    50% { content: '..'; }
    75% { content: '...'; }
    100% { content: ''; }
}
.chatContatiner {
    padding: 0px 20px;

   
}

.chat-bubble {
    width: 100%;
    color: #333;
    border-radius: 5px;
    box-shadow: 3px 5px 15px rgba(0, 0, 0, .2);
    padding: 5px 10px;
    width: auto;
    max-width: 100%;
    text-align: left;
    display: inline-block !important;
    position: relative;
    word-break: break-all;
    background-color: #ffffff;
    transition: all .2s;
    cursor: pointer;
}

.chat-bubble:hover {
    transform: scale(1.03);
}

.chat-bubble-left {}

.chat-bubble-left.ai-chat {
    border: 1px solid;
    border-image: linear-gradient(90deg, #725bdf 0%, #80a3d5 70%, #bdceea 100%) 1 1 1 1;

}


.chat-bubble-left::before {
    content: '';
    width: 10px;
    height: 10px;
    left: -10px;
    top: calc(50% - 5px);
    position: absolute;
    border-left: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid #7d93d7;
}

.chat-bubble-right {
    background-color: #e0dfff;
}

.chat-bubble-right:after {
    content: '';
    width: 10px;
    height: 10px;
    right: -10px;
    top: calc(50% - 5px);
    position: absolute;
    border-left: 5px solid #e0dfff;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
}

.chatContainer {
    padding: 10px;
}

.QICONIcon {
    display: flex;
    width: 100%;
    height: 100%;
    background: #725bdf;
    align-items: center;
    justify-content: center;
}

.QICON {
    margin-bottom: 10px;
    width: 30px;
    height: 30px;

    display: flex;
    justify-content: center;
    align-items: center;


}
.knowledgeRefContent {

		 display: flex;
		            flex-direction: column;   
		background-color: white;
		
		position: absolute ;
		color: #2196F3;
		left: 0;
		right: 0;
		margin: auto;
		
		width: 90%;


		padding: 20px 10px;
		border-radius: 10px;
		box-shadow: rgb(149 157 165 / 59%) 1px -1px 24px 12px;
}
</style>